<template>
    <div class="footerbox">
        <div class="container_box">
            <div class="com_info">
                <div class="left_info">
                    <div class="com_title">
                        {{ appTitle }}
                    </div>
                    <div class="connect">
                        <div class="c_left">
                            <span class="iconfont icon-dianhua"></span>
                        </div>
                        <div class="c_right">
                            <div class="desc">技术服务热线:</div>
                            <div class="phoneNumber">{{ rexian }}</div>
                        </div>
                    </div>
                </div>
                <div class="right_info">
                    <div class="code_box" v-if="wxcode">
                        <img :src="wxcode" v-if="wxcode.indexOf('http') != -1" alt="">
                        <img :src="$imgUrl + wxcode" v-else alt="">
                        <div class="name">微信公众号</div>
                    </div>
                    <div class="code_box" v-if="ercode">
                        <img class="a" :src="ercode" v-if="ercode.indexOf('http') != -1" alt="">
                        <img class="b" :src="$imgUrl + ercode" v-else alt="">
                        <div class="name">微信小程序</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- beian -->
        <div class="bei_an_info">
            <div class="bei_content">
               {{ appTitle }}  <a  href="https://beian.miit.gov.cn/" target="_blank" style="color:#fff;">   豫ICP 备 09006662号-10</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                ercode: "",
                wxcode: "",
                appTitle:"",
                rexian:""
            }
        },
        mounted() {
            this.getErcode()
            this.getwxcode()
            this.getTitle()
            this.getReXian()
        },
        methods: {
             // 获取微信小程序图片
            async getErcode() {
                let res = await this.$axios.post("/lencon/pc/index/theme", { id: 9 })
                if ( res.data.code == 1 ) {
                    this.ercode = res.data.res.img
                }
            },
            // 获取微信公众号图片
            async getwxcode() {
                let res = await this.$axios.post("/lencon/pc/index/theme", { id: 10 })
                if ( res.data.code == 1 ) {
                    this.wxcode = res.data.res.img
                }
            },
            // 获取项目标题
            async getTitle(){
                let res = await this.$axios.post("/lencon/pc/index/theme", { id: 4 })
                this.appTitle = res.data.res.font || "智慧工会云平台"
                this.$store.commit("getAppTitle", this.appTitle)
                localStorage.setItem("appTitle", this.appTitle)
                document.title = this.appTitle
            },

            // 获取热线
            async getReXian(){
                let res = await this.$axios.post("/lencon/pc/index/theme", { id: 6 })
                this.rexian = res.data.res.font
            },
        }
    }
</script>

<style lang="scss" scoped>
.footerbox {
    width: 100%;
    height: 270px;
    box-sizing: border-box;
    background: #275FB1 ;
    position: relative;
    left: 0;
    top: 0;
    .container_box {
        width: 1200px;
        margin: 0 auto;
        .com_info {
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-top: 50px;
            .left_info {
                .com_title {
                    font-size: 26px;
                    font-weight: bold;
                    color:#fff;
                }
                .connect {
                    display: flex;
                    align-items: center;
                    color: #fff;
                    margin-top: 20px;
                    .c_left {
                        span {
                            font-size: 40px;
                        }
                    }
                    .c_right {
                        margin-left: 10px;
                        .desc {
                            font-size: 14px;
                        }
                        .phoneNumber {
                            font-size: 20px;
                            font-weight: bold;
                        }
                    }
                }
            }

            .right_info {
                display: flex;
                .code_box {
                    margin: 10px;
                    text-align: center;
                    color: #fff;
                    font-size: 14px;
                    img {
                        width: 110px;
                        height: 110px;
                    }
                }
            }
        }
    }

    .bei_an_info {
        width: 100%;
        // width: 100%;
        height: 55px;
        box-sizing: border-box;
        background: #1B4A9E;
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 2;
        .bei_content {
            width: 1200px;
            height: 55px;
            margin: 0 auto;
            line-height: 55px;
            color: #fff;
            text-align: center;
            font-size: 14px;
        }
    }
}
</style>